<template>
  <KombiSchritt4Endkunde v-if="store.aok === 0"></KombiSchritt4Endkunde>
  <KombiSchritt4Aok v-if="store.aok > 0"></KombiSchritt4Aok>
</template>

<script setup>

import { useRechnerStore } from '@/stores/rechner';
import KombiSchritt4Endkunde from '@/components/kombi/kombi_schritt4_endkunde.vue';
import KombiSchritt4Aok from '@/components/kombi/kombi_schritt4_aok.vue';
const store = useRechnerStore();


</script>